import { render } from "./BannerHeader.vue?vue&type=template&id=e4c3cd82&scoped=true"
import script from "./BannerHeader.vue?vue&type=script&lang=js"
export * from "./BannerHeader.vue?vue&type=script&lang=js"

import "./BannerHeader.vue?vue&type=style&index=0&id=e4c3cd82&scoped=true&lang=css"

import exportComponent from "/cwt/data/jenkins/workspace/RoomIt-HotelWeb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4c3cd82"]])

export default __exports__